<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
        <a href="/">首页</a> <span class="sep">/</span> <span>交易订单</span>
      </div>
    </div>
    <div class="mi-orderlist">
      <div class="container ">
        <div class="row">
          <div class="span4">
            <left-nav></left-nav>
          </div>
          <div class="span16">
            <div class="mi-uc-box">
              <div class="box-hd">
                <h1 class="title">
                  订单详情
                </h1>
                <div class="more clearfix">
                  <h2 class="subtitle">
                    订单号：{{ order.order_no }}
                    <!---->
                  </h2>
                  <div class="actions">
                    <div class="status-btn-box">
                      <a @click="popup_kf()" class="btn btn-small  btn-contract"
                        >联系客服
                      </a>
                      <a
                        v-show="order.status === 'WAIT_BUYER_CONFIRM_GOODS'"
                        @click="onReceived"
                        class="btn btn-small btn-primary"
                        >确认收货
                      </a>
                      <a
                        v-show="order.status == ''"
                        title="申请售后"
                        class="btn btn-small btn-line-gray"
                        >申请售后
                      </a>
                      <a
                        v-show="order.status == 'WAIT_BUYER_PAY'"
                        title="立即支付"
                        class="btn btn-small btn-primary"
                        @click="goConfirm"
                        >立即支付
                      </a>
                      <a
                        v-show="
                          order.status == 'WAIT_BUYER_PAY' &&
                            order.pay_type == 'bank'
                        "
                        title="上传付款凭证"
                        class="btn btn-small btn-primary"
                        @click="goVoucher"
                        >上传付款凭证
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-bd">
                <div class="order-detail uc-order-item-finish">
                  <div data-v-10ff82cc="" class="order-summary">
                    <!---->
                    <div data-v-10ff82cc="" class="order-status">
                      <div data-v-10ff82cc="" style="display: inline-block;">
                        {{ order.status_text }}
                      </div>
                    </div>
                    <!---->
                    <el-steps :space="200" :active="1" simple>
                      <el-step title="下单" icon="el-icon-edit"></el-step>
                      <el-step title="付款" icon="el-icon-upload"></el-step>
                      <el-step title="出库" icon="el-icon-picture"></el-step>
                      <el-step
                        title="交易成功"
                        icon="el-icon-picture"
                      ></el-step>
                    </el-steps>
                  </div>
                  <div
                    class="order-goods"
                    style="border-top:1px solid #ccc;margin-bottom:20px;"
                  >
                    <table class="goods-table">
                      <tr
                        class="goods-box"
                        v-for="(item, index) in order.item_list"
                        :key="index"
                      >
                        <td class="col col-thumb">
                          <div class="figure figure-thumb">
                            <a
                              target="_blank"
                              :href="'/detail/' + item.goods_id"
                            >
                              <el-image
                                :src="item.goods_image"
                                style="width:80px;height:80px;margin-top:10px;margin-bottom:10px;"
                              >
                              </el-image>
                            </a>
                          </div>
                        </td>
                        <td colspan="3" class="col col-info">
                          <table class="col-info-box">
                            <tr class="goods-box-info">
                              <td class="col col-name">
                                <div class="name">
                                  <a
                                    target="_blank"
                                    :href="'/detail/' + item.goods_id"
                                  >
                                    {{ item.goods_name }}
                                  </a>
                                </div>
                              </td>
                              <td class="col col-price">
                                <p class="price">
                                  {{ item.price }}元 × {{ item.qty }}
                                </p>
                              </td>
                              <td class="col col-actions">
                                {{ item.amount }}元
                              </td>
                            </tr>
                            <!---->
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <!---->
                <div class="order-detail-info">
                  <h3>收货信息</h3>
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <th>
                          姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：
                        </th>
                        <td>{{ order.user_name }}</td>
                      </tr>
                      <tr>
                        <th>联系电话：</th>
                        <td>{{ order.user_mobile }}</td>
                      </tr>
                      <tr>
                        <th>收货地址：</th>
                        <td>{{ order.user_area }} {{ order.user_address }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="actions"><!----><!----></div>
                </div>
                <div data-v-942b74ea="" class="order-detail-info">
                  <h3 data-v-942b74ea="">支付方式<!----></h3>
                  <table data-v-942b74ea="" class="info-table">
                    <tbody data-v-942b74ea="">
                      <tr data-v-942b74ea="">
                        <th data-v-942b74ea="">支付方式：</th>
                        <td data-v-942b74ea="">{{ order.pay_type_text }}</td>
                      </tr>
                      <!----><!---->
                    </tbody>
                  </table>
                  <div data-v-942b74ea="" class="actions"></div>
                </div>
                <div>
                  <div class="order-detail-info">
                    <h3>发票信息</h3>
                    <table class="info-table">
                      <tbody>
                        <tr>
                          <th>发票类型：</th>
                          <td>电子普通发票</td>
                        </tr>
                        <tr>
                          <th>发票内容：</th>
                          <td>购买商品明细</td>
                        </tr>
                        <tr>
                          <th>发票抬头：</th>
                          <td>个人</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="actions">
                      <a
                        href="https://api2.order.mi.com/order_center/display_invoice?order_id=5210813493700697&amp;invoice_id=1537495765144698880"
                        target="_blank"
                        class="btn btn-small btn-line-gray"
                        >查看发票</a
                      ><a
                        href="javascript:void(0);"
                        class="btn btn-small btn-line-gray"
                        >发票换开</a
                      ><!---->
                    </div>
                    <!---->
                  </div>
                </div>
                <div data-v-50b144cc="" class="order-detail-total">
                  <table data-v-50b144cc="" class="total-table">
                    <tbody data-v-50b144cc="">
                      <tr data-v-50b144cc="">
                        <th data-v-50b144cc="">商品总价：</th>
                        <td data-v-50b144cc="">
                          <span data-v-50b144cc="" class="num">{{
                            order.total_amount
                          }}</span
                          >元
                        </td>
                      </tr>
                      <!----><!----><!---->
                      <tr data-v-50b144cc="">
                        <th data-v-50b144cc="">运费：</th>
                        <td data-v-50b144cc="">
                          <span data-v-50b144cc="" class="num">{{
                            order.freight_amount
                          }}</span
                          >元
                        </td>
                      </tr>
                      <!----><!---->
                      <tr data-v-50b144cc="">
                        <th data-v-50b144cc="" class="total">实付金额：</th>
                        <td data-v-50b144cc="" class="total">
                          <span data-v-50b144cc="" class="num">{{
                            order.total_payment
                          }}</span
                          >元
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="is_popup_voucher" title="上传付款凭证" width="430px">
      <div style="text-align:center">
        <el-upload
          class="upload-demo"
          :action="qiniu_upload_url"
          :on-success="onSuccess"
          :data="qiniu_params"
          drag
          multiple
          style="margin-bottom:20px;"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处,或<em>点击上传</em></div>
          <template #tip>
            <div class="el-upload__tip">
              只能上传jpg/png文件，且不超过2M
            </div>
          </template>
        </el-upload>
        <el-button type="primary" @click="submitVoucher()">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog v-model="is_popup_received" title="确认收货">
      <span>请收到商品检查无误后再确认收货</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_popup_received = false">取消</el-button>
          <el-button type="primary" @click="saveReceived">确认</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="is_show_kf" width="300px">
      <el-image :src="require('@/assets/image/kf_qrcode.png')"> </el-image>
      <div style="text-align:center">微信扫一扫</div>
    </el-dialog>
  </div>
</template>
<script>
import LeftNav from "../Layout/LeftNav.vue";
import { api } from "@/assets/js/util.js";
export default {
  name: "Profile",
  components: {
    "left-nav": LeftNav,
  },
  data() {
    return {
      is_show_kf: false,
      qiniu_params: {},
      qiniu_upload_url: "",
      qiniu_domain: "",
      is_popup_voucher: false,
      is_popup_received: false,
      order: {},
      form: {
        fileList: [],
      },
    };
  },
  mounted() {
    this.getToken();
    this.getData();
  },
  methods: {
    popup_kf() {
      this.is_show_kf = true;
    },
    onReceived() {
      this.is_popup_received = true;
    },
    saveReceived() {
      let that = this;
      api.post("order/received", this.order).then(function(res) {
        if (res.code) {
          that.$message("确认收货");
          that.is_popup_received = false;
          that.getData();
        }
      });
    },
    getToken() {
      let that = this;
      api.get("qiniu/token").then(function(res) {
        that.qiniu_upload_url = res.data.qiniu_upload_url;
        that.qiniu_params.token = res.data.token;
        that.qiniu_domain = res.data.qiniu_domain;
      });
    },
    onSuccess(res, file, fileList) {
      let that = this;
      that.form.fileList = fileList;
    },
    getData() {
      let that = this;

      let params = {
        order_no: that.$route.params["order_no"],
      };
      api.post("order/detail", params).then(function(res) {
        if (res.code) {
          that.order = res.data;
        }
      });
    },
    goConfirm() {
      this.$router.push("/order/confirm/" + this.order.id);
    },
    goVoucher() {
      this.is_popup_voucher = true;
    },
    submitVoucher() {
      let that = this;
      if (that.form.fileList.length === 0) {
        that.$message.error("请上传付款凭证");
      }

      let params = {
        file_list: that.form.fileList,
        order: that.order,
      };
      api.post("order/upload_voucher", params).then(function(res) {
        if (res.code) {
          that.is_popup_voucher = false;
          that.getData();
        }
      });
    },
  },
};
</script>
<style scoped>
.progress-list .step[data-v-10ff82cc] {
  flex-basis: 100%;
}

.goods-box {
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
}

.order-detail-info {
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
  position: relative;
}

.order-detail-info h3 {
  font: 14px/1.5 Helvetica Neue, Helvetica, Arial, Microsoft Yahei,
    Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #333;
}

.order-detail-info th {
  border-collapse: collapse;
  border-spacing: 0;
  color: #757575;
  padding: 3px 0;
  text-align: left;
  padding-right: 0.3em;
}
.order-detail-info td {
  border-collapse: collapse;
  border-spacing: 0;
  color: #757575;
  padding: 3px 0;
  text-align: left;
}
.order-detail-info .actions {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 120px;
}
</style>
